import StouxLogo from '@/components/atoms/StouxLogo/StouxLogo'
import { SearchBar } from '@/components/organisms/SearchBar'
import { useAccountContext } from '@/contexts/account-context'
import { FeatureFlagContext } from '@/contexts/FeatureFlagsContext'
import {
    Box,
    Button,
    Divider,
    Drawer,
    DrawerProps,
    Indicator,
    Space,
    Stack,
    Text,
    ThemeIcon,
} from '@mantine/core'
import {
    Facebook,
    Instagram,
    Twitter,
    Store,
    LogIn,
    LogOut,
    HandHeart,
    MessageSquare,
    ShoppingCart,
    Truck,
    User,
    UserPlus,
} from 'lucide-react'
import { useStore } from '@/contexts/store-context'
import Link from 'next/link'
import { useContext } from 'react'
import { getStore } from '@/utils/store'

const MobileMenu = ({
    opened,
    onClose,
    onOpenCart,
    onOpenStoreList,
}: DrawerProps & {
    onOpenCart?: () => void
    onOpenStoreList?: () => void
}) => {
    const { totalItems } = useStore()
    const { customer, logout } = useAccountContext()
    const { isFeatureEnabled } = useContext(FeatureFlagContext)

    const store = getStore();

    return (
        <Drawer position="right" opened={opened} onClose={onClose}>
            <Drawer.Header>
                <Stack className="items-center w-full">
                    <StouxLogo className="max-w-[6rem] lg:max-w-[4rem] xl:max-w-[6rem] text-primary transition-all duration-200 ease-out cursor-pointer hover:scale-105 hover:text-primary" />
                </Stack>
            </Drawer.Header>
            
            <Space h="md" />
            <Drawer.Body>
                <Stack spacing="md" >
                    <div className="flex flex-col">
                        {isFeatureEnabled('cart') && (
                            <>
                                {!!totalItems && (
                                    <Indicator
                                        label={totalItems}
                                        size={24}
                                        className="w-full z-20"
                                        onClick={onOpenCart}
                                        color="red"
                                        position="top-end"
                                       styles={{
                                            indicator: {
                                            outline: '2px solid white',
                                            }
                                        }}
                                    >
                                        <Button
                                            size="sm"
                                            style={{ backgroundColor: 'var(--primary)', color: 'white' }}
                                            fullWidth
                                            mb="sm"
                                            leftIcon={
                                                <ShoppingCart className="absolute w-6 h-6 left-4" />
                                            }
                                        >
                                            Mon panier
                                        </Button>
                                    </Indicator>
                                )}

                                {!totalItems && (
                                    <Button
                                        size="sm"
                                        style={{ backgroundColor: 'var(--primary)', color: 'white' }}
                                        fullWidth
                                        mb="sm"
                                        leftIcon={
                                            <ShoppingCart className="absolute w-6 h-6 left-4" />
                                        }
                                    >
                                        Mon panier
                                    </Button>
                                )}
                                {!store && (
                                    <Button
                                    size="xs"
                                    variant="subtle"
                                    color="gray"
                                    fullWidth
                                    onClick={onOpenStoreList}
                                    leftIcon={
                                        <Store className="absolute w-4 h-4 left-4" />
                                    }
                                        >
                                    Voir les magasins
                                </Button>
                                )}
                                
                            </>
                        )}
                        <Space h="xl" />
                        {isFeatureEnabled('account') && (
                            <>
                                <Text
                                    size="xs"
                                    c="gray.8"
                                    className="font-medium"
                                >
                                    Navigation
                                </Text>

                                <Stack spacing="lg" mt="sm">
                                    {!!customer ? (
                                        <>
                                            <Link
                                                href="/account"
                                                className="w-full"
                                            >
                                                <Button
                                                    size="xs"
                                                    variant="subtle"
                                                    color="gray"
                                                    fullWidth
                                                    leftIcon={
                                                        <User className="absolute w-4 h-4 left-4" />
                                                    }
                                                >
                                                    Mon compte
                                                </Button>
                                            </Link>
                                            <Link
                                                href="/account?tab=orders"
                                                className="w-full"
                                            >
                                                <Button
                                                    size="xs"
                                                    variant="subtle"
                                                    color="gray"
                                                    fullWidth
                                                    leftIcon={
                                                        <Truck className="absolute w-4 h-4 left-4" />
                                                    }
                                                >
                                                    Mes commandes
                                                </Button>
                                            </Link>

                                            <Link
                                                href="/account?tab=messages"
                                                className="w-full"
                                            >
                                                <Button
                                                    size="xs"
                                                    variant="subtle"
                                                    color="gray"
                                                    fullWidth
                                                    leftIcon={
                                                        <MessageSquare className="absolute w-4 h-4 left-4" />
                                                    }
                                                >
                                                    Messagerie
                                                </Button>
                                            </Link>
                                            <Button
                                                size="xs"
                                                variant="light"
                                                color="red.5"
                                                fullWidth
                                                onClick={logout}
                                                leftIcon={
                                                    <LogOut className="absolute w-4 h-4 left-4" />
                                                }
                                            >
                                                Déconnexion
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Link
                                                href="/sign-in"
                                                className="w-full"
                                            >
                                                <Button
                                                    size="xs"
                                                    variant="white"
                                                    color="gray"
                                                    fullWidth
                                                    leftIcon={
                                                        <LogIn className="absolute w-4 h-4 left-4" />
                                                    }
                                                >
                                                    Se connecter
                                                </Button>
                                            </Link>
                                            <Link
                                                href="/register"
                                                className="w-full"
                                            >
                                                <Button
                                                    size="xs"
                                                    variant="white"
                                                    color="gray"
                                                    fullWidth
                                                    leftIcon={
                                                        <UserPlus className="absolute w-4 h-4 left-4" />
                                                    }
                                                >
                                                    Créer mon compte
                                                </Button>
                                            </Link>
                                        </>
                                    )}
                                </Stack>
           
                            </>
                        )}

                    </div>
                </Stack>
            </Drawer.Body>
        </Drawer>
    )
}

export default MobileMenu
